
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowBack as ObiSignArrowBackElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-back.js';
 
 
 

 
 export const ObiSignArrowBack = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-back',
   elementClass: ObiSignArrowBackElement,
   events: {
     
   }
  });
 
 